module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Calculator-493d088895efc802fe87a6d70e86cfd4.svg";